import { render, staticRenderFns } from "./ActivityLogDetail.vue?vue&type=template&id=288ad007&scoped=true"
import script from "./ActivityLogDetail.vue?vue&type=script&lang=js"
export * from "./ActivityLogDetail.vue?vue&type=script&lang=js"
import style0 from "./ActivityLogDetail.vue?vue&type=style&index=0&id=288ad007&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288ad007",
  null
  
)

export default component.exports